import { Controller } from '@hotwired/stimulus'
import { t } from '@lingui/core/macro'

export default class extends Controller {
  static targets = [
    'bucketName',
    'bucketPrefix',
    'downloadLink',
    'policyJson',
    'manualBucket',
    'manualPrefix',
    'manualReportName',
  ]
  static values = { baseUrl: String }

  connect() {
    this.updateManualTab()
  }

  download(event) {
    const bucketName = this.bucketNameTarget.value.trim()
    const bucketPrefix = this.bucketPrefixTarget.value.trim()

    if (!bucketName || !bucketPrefix) {
      event.preventDefault()
      alert(t`Please fill in both S3 Bucket Name and S3 Prefix fields.`)
      return
    }

    const url = new URL(this.baseUrlValue, window.location.origin)
    url.searchParams.set('s3_bucket_name', bucketName)
    url.searchParams.set('s3_bucket_prefix', bucketPrefix)

    this.downloadLinkTarget.href = url.toString()
  }

  updateManualTab() {
    const bucketName = this.bucketNameTarget.value.trim() || 'YOUR_BUCKET_NAME'
    const fullPrefix = this.bucketPrefixTarget.value.trim()
    const lastSlash = fullPrefix.lastIndexOf('/')
    const prefix = lastSlash > 0 ? fullPrefix.substring(0, lastSlash) : fullPrefix
    const reportName = lastSlash > 0 ? fullPrefix.substring(lastSlash + 1) : ''
    const skieArn = this.policyJsonTarget.dataset.skieArn

    const policy = {
      Version: '2012-10-17',
      Statement: [
        {
          Sid: 'AllowDataExportsGetBucketAcl',
          Effect: 'Allow',
          Principal: { Service: 'bcm-data-exports.amazonaws.com' },
          Action: ['s3:GetBucketAcl', 's3:GetBucketPolicy'],
          Resource: `arn:aws:s3:::${bucketName}`,
          Condition: { StringEquals: { 'aws:SourceAccount': 'YOUR_ACCOUNT_ID' } },
        },
        {
          Sid: 'AllowDataExportsPutObject',
          Effect: 'Allow',
          Principal: { Service: 'bcm-data-exports.amazonaws.com' },
          Action: ['s3:PutObject'],
          Resource: `arn:aws:s3:::${bucketName}/${prefix}/*`,
          Condition: { StringEquals: { 'aws:SourceAccount': 'YOUR_ACCOUNT_ID' } },
        },
        {
          Sid: 'AllowSkieReaderAccess',
          Effect: 'Allow',
          Principal: { AWS: skieArn },
          Action: ['s3:GetObject', 's3:ListBucket'],
          Resource: [`arn:aws:s3:::${bucketName}`, `arn:aws:s3:::${bucketName}/*`],
        },
      ],
    }

    this.policyJsonTarget.textContent = JSON.stringify(policy, null, 2)
    this.manualBucketTargets.forEach((el) => {
      el.textContent = bucketName
    })
    this.manualPrefixTargets.forEach((el) => {
      el.textContent = prefix
    })
    this.manualReportNameTargets.forEach((el) => {
      el.textContent = reportName
    })
  }
}
